import { useState, useEffect, useContext } from 'react';

function Loading(props: any) {
  const loadingWidth = props.width
    ? props.width : '15%';
  return (
    <div className="text-center">
      <img src="/images/svg/spinner.svg" width={loadingWidth} />
      </div>
  );
}

export default Loading;